import { Analytics } from "analytics";
import { urlsPixelPlugin } from "./plugins/urls/index.js";
import { sourcePixelPlugin } from "./plugins/source-pixel/index.js";
function createAnalyticsCore(config) {
  const { app, version, plugins, debug } = config;
  const _analytics = Analytics({
    debug,
    app,
    version,
    plugins
  });
  const analyticsInstance = {
    ..._analytics,
    // it's annoying to have to catch errors every time we want to track something, so we'll just do it here
    track(...args) {
      _analytics.track(...args).catch(console.error);
    },
    async trackAsync(...args) {
      return await _analytics.track(...args);
    },
    eventOnce(event, callback) {
      const trackListener = _analytics.on("trackStart", ({ payload }) => {
        if (payload.event === event) {
          callback(payload);
          trackListener();
        }
      });
    },
    installedPlugins: plugins
  };
  return analyticsInstance;
}
function createAnalytics(config) {
  const { getSettings, pluginOptions, additionalPlugins = [], ...coreConfig } = config;
  const settings = getSettings();
  const enabled = isAnalyticsEnabled(settings);
  const plugins = [
    sourcePixelPlugin({
      ...pluginOptions.sourcePixel,
      enabled
    }),
    urlsPixelPlugin({
      ...pluginOptions.urls,
      enabled: enabled && isPixelEnabled(settings, "urls"),
      getUrlPixelConfig: () => {
        var _a, _b;
        return (_b = (_a = settings.pulse) == null ? void 0 : _a.pixels) == null ? void 0 : _b.urls;
      }
    }),
    ...additionalPlugins
  ];
  return createAnalyticsCore({ ...coreConfig, plugins });
}
function isAnalyticsEnabled(settings) {
  var _a;
  return ((_a = settings.pulse) == null ? void 0 : _a.enabled) ?? true;
}
function isPixelEnabled(settings, pixel) {
  var _a, _b, _c;
  return ((_c = (_b = (_a = settings.pulse) == null ? void 0 : _a.pixels) == null ? void 0 : _b[pixel]) == null ? void 0 : _c.enabled) === true;
}
export {
  createAnalytics,
  createAnalyticsCore,
  isAnalyticsEnabled,
  isPixelEnabled
};
